import { render, staticRenderFns } from "./alias-change-sheet.vue?vue&type=template&id=9167668e&scoped=true&"
import script from "./alias-change-sheet.vue?vue&type=script&lang=js&"
export * from "./alias-change-sheet.vue?vue&type=script&lang=js&"
import style0 from "./alias-change-sheet.vue?vue&type=style&index=0&id=9167668e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9167668e",
  null
  
)

export default component.exports